import errorCodes from './ErrorCodes.js'

function getErrorType( err ) {
    let error = {
        code : null,
        message: 'Unknown error',
        status : 'error'
    };
    //
    //Cannot identify exception
    //
    if ('code' in err !== true || 'response' in err !== true) {
        console.log('Cannot identify exception')
        return error;
    }
    //
    //Exception comes from the client
    //
    if (err.code != null) {
        error.code = errorCodes.ERRCODE_TIMEOUT;
        error.message = 'Please check your network connection!';
        error.status = "error";
    }

    //
    //Exception comes from the server
    //
    switch (err.response.status) {
        case 400 :
            error.code= errorCodes.ERRCODE_400;
            error.message = 'Bad request!';
            error.status = "error";
        case 401 :
            error.code= errorCodes.ERRCODE_401;
            error.message = 'Unauthorized access!';
            error.status = "error";
        case 403 :
            error.code= errorCodes.ERRCODE_403;
            error.message = 'Forbidden!';
            error.status = "error";
        case 404 :
            error.code= errorCodes.ERRCODE_404;
            error.message = 'The resource is not found!';
            error.status = 404;
        case 408 :
            error.code= errorCodes.ERRCODE_408;
            error.message = 'Tiemout! Please try again later!';
            error.status = "error";
        case 500 :
            error.code= errorCodes.ERRCODE_500;
            error.message = 'Internal errors!';
            error.status = 500;
        default :
            error.code= errorCodes.ERRCODE_UNKNOWN;
            error.message = 'Internal errors!';
            error.status = "error";
    }

    return error;
        
}


export default {
    getErrorType
}